import { useRequest } from './chunk-VAEV7IZU.mjs';
import { graphql } from './chunk-FNXRYVXB.mjs';
import { __export } from './chunk-YUBKM3FG.mjs';

// src/listen/query-hooks/audios.ts
var audios_exports = {};
__export(audios_exports, {
  useLoadAudios: () => useLoadAudios,
  useLoadPublicAudios: () => useLoadPublicAudios
});
var audiosAndFeelingsQuery = graphql(`
  query GetAudiosAndFeelings @cached {
    audios {
      id
      name
      source
      thumbnailUrl
      public
      artistName
      createdAt
      audio_tags {
        tag_id
      }
    }
    tags(where: { site: { _eq: "listen" } }) {
      id
      name
    }
  }
`);
var publicAudiosAndFeelingsQuery = graphql(`
  query GetPublicAudiosAndFeelings @cached {
    audios(where: { public: { _eq: true } }) {
      id
      name
      source
      thumbnailUrl
      artistName
      audio_tags {
        tag_id
      }
    }
    tags(where: { site: { _eq: "listen" }, audio_tags: { audio: { public: { _eq: true } } } }) {
      id
      name
    }
  }
`);
var useLoadAudios = (props) => {
  const { getAccessToken } = props;
  const rs = useRequest({
    queryKey: ["audios-and-feelings"],
    getAccessToken,
    document: audiosAndFeelingsQuery
  });
  return rs;
};
var useLoadPublicAudios = () => {
  const rs = useRequest({
    queryKey: ["public-audios-and-feelings"],
    document: publicAudiosAndFeelingsQuery
  });
  return rs;
};

export { audios_exports, useLoadAudios, useLoadPublicAudios };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-3CHL5YJA.mjs.map